import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppConfig } from 'src/assets/config/config/app-config';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    aclGroup: any = this.config.getACLGroup();

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private config: AppConfig
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // authorised so return true
            //console.log("User " + JSON.stringify(currentUser));
            if (route && route.url.length > 0 && route.url[0].path == "home") {
                if (this.aclGroup.group === 'CA') {
                    this.router.navigate(['/categories']);
                }
            }
            return true;
        }
                
        // not logged in so redirect to login page with the return url
        if (this.aclGroup.group === 'CA') {
            this.router.navigate(['/ssologin']);
        } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});            
        }
        return false;
    }
}